import { render, staticRenderFns } from "./TableMusicBgm.vue?vue&type=template&id=bef89dce&scoped=true&"
import script from "./TableMusicBgm.vue?vue&type=script&lang=js&"
export * from "./TableMusicBgm.vue?vue&type=script&lang=js&"
import style0 from "./TableMusicBgm.vue?vue&type=style&index=0&id=bef89dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef89dce",
  null
  
)

export default component.exports